import { useState } from "react";
import { TreeStructureEntity } from "./utils";
import { Xwrapper } from "react-xarrows";
import { LeaderLine } from "@/components/shared/leader-line";
import { Card, CardContent } from "@/components/ui/card";
import { useScroll } from "@/hooks/use-scroll";

/* eslint-disable @typescript-eslint/no-explicit-any */
export const TreeStructure = ({
  data,
  onChange,
  onTreeMutation,
  onTreeFormSubmit,
  erpListData,
  manageUpdateData,
  orderTypeList,
  sortingTree,
  support_multi_doc_type,
}: any) => {
  const { y } = useScroll("synonym-tree-structure");

  const [activeNode, setActiveNode] = useState("");
  const [activeRef, setActiveRef] = useState({ ref1: null, ref2: null });

  const setNode = (prop: string) => {
    if (activeNode === prop) {
      setActiveNode("");
    } else {
      setActiveNode(prop);
    }
  };

  function updateNestedProperty(obj: any, path: string, value: string[]) {
    const keys = path.split(".");
    const newObj = structuredClone(obj); // Deep clone the object

    let current = newObj;
    for (let i = 0; i < keys.length - 1; i++) {
      current = current[keys[i]];
    }

    current[keys[keys.length - 1]] = value;

    return newObj;
  }

  const onTreeChange = (prop: any) => {
    const tempData = structuredClone(data);

    console.log({ prop, tempData });

    if (prop?.parentKey?.[0]) {
      manageUpdateData(prop?.parentKey?.[0]);
    }

    let newData = tempData;
    if (prop.document_types) {
      newData = updateNestedProperty(
        tempData,
        `${prop.parentKey}.document_types`,
        prop.document_types
      );
    }
    if (prop.data_type) {
      newData = updateNestedProperty(tempData, prop.parentKey, prop.data_type);
    }
    if (prop.synonyms) {
      newData = updateNestedProperty(tempData, prop.parentKey, prop.synonyms);
    }

    if (prop.type) {
      newData = updateNestedProperty(tempData, prop.parentKey, prop.type);
    }

    onChange(newData);
  };

  return (
    <Card className="overflow-hidden relative ">
      <CardContent
        className="max-w-[100%] p-0 overflow-auto scrollbar h-auto min-h-[350px] md:h-[calc(100dvh-340px)]"
        id={"synonym-tree-structure"}
      >
        <Xwrapper>
          <div className="p-5 w-full flex h-full gap-[120px] ">
            <div className="w-[56%]">
              {data?.map((item: any, index: number) => {
                return (
                  <TreeStructureEntity
                    config={[activeNode, setNode]}
                    data={item}
                    key={index}
                    setActiveRef={setActiveRef}
                    parentKey={"" + index}
                    onTreeChange={onTreeChange}
                    erpListData={erpListData}
                    orderTypeList={orderTypeList}
                    onTreeMutation={(prop: any) => {
                      onTreeMutation(prop);
                    }}
                    treeId={item.domain_id}
                    onTreeFormSubmit={onTreeFormSubmit}
                    sortingTree={sortingTree}
                    support_multi_doc_type={support_multi_doc_type}
                  />
                );
              })}
              <LeaderLine ref1={activeRef.ref1} ref2={activeRef.ref2} y={y} />
            </div>
            <div className="w-[400px] h-full">
              <div className="h-full " id="tree-structure-details-node"></div>
            </div>
          </div>
        </Xwrapper>
      </CardContent>
    </Card>
  );
};
